export default __webpack_public_path__ + "static/EoW-Horizontal-logo_TM_noBackgroundcolor-ff0ad615fd45c252abbe0b2e5a846a9a.svg";